import React from 'react';
import { LinkProps } from 'react-router-dom';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

export const AuditLookupLink: React.FC<
  React.PropsWithoutRef<LinkProps> & React.RefAttributes<HTMLAnchorElement>
> = props => {
  const { isRemoAdmin } = useRemoAdminCtx();
  const urlPrefix = isRemoAdmin ? 'tools/' : '/corp/';
  return (
    <a
      {...props}
      href={urlPrefix + removeLeadingBackslash(props.to as string)}
      target="_blank"
      rel="noopener noreferrer"
    ></a>
  );
};

export const AuditPodLeadLink: React.FC<
  React.PropsWithoutRef<LinkProps> & React.RefAttributes<HTMLAnchorElement>
> = props => {
  const { isRemoAdmin } = useRemoAdminCtx();
  const urlPrefix = isRemoAdmin ? '' : '/corp/';
  return (
    <a
      {...props}
      href={urlPrefix + removeLeadingBackslash(props.to as string)}
      target="_blank"
      rel="noopener noreferrer"
    ></a>
  );
};

const removeLeadingBackslash = (url: string) => {
  if (url.startsWith('/')) {
    return url.slice(1);
  }
  return url;
};
